<template>
  <el-container class="list-question-wrap">
    <el-header style="text-align:left">
      <div class="manage-head">
        <div class="text">
          <span>病人管理 / </span><span>会员审核</span>
        </div>
      </div>
    </el-header>
    <el-main style="padding-bottom:0">
      <div class="main-content-list" style="height:100vh;">
        <!-- 机构自定义 -->
        <!-- <div v-if="orgHospitalId == '1630497377808076802'"> -->
        <div>
          <div class="open-tag">
            <div class="tag-title"><span></span>
              <p>机构自定义</p>
            </div>
            <!-- <div class="open-status" v-if="openCustom" @click="handleFoldCustom">收起 <i class="el-icon-arrow-up"></i>
            </div>
            <div class="open-status" v-else @click="handleFoldCustom">展开 <i class="el-icon-arrow-down"></i> </div> -->
            <div class="btn">
              <el-button type="primary" plain @click="isEdit = !isEdit" v-if="!isEdit" size="small">编辑</el-button>
              <el-button type="primary" plain @click="submitHandel" v-else size="small">保存</el-button>
            </div>
          </div>
          <div v-show="openCustom" class="openCustom-box">
            <!-- <el-tooltip placement="top">
                <div slot="content">多行信息<br/>第二行信息</div>
                <div size="small" slot="reference" type="text">补卡1</div>
              </el-tooltip> -->
            <el-form :model="ruleForm" :rules="rulesqw" size="mini" ref="ruleForm" label-width="142px"
              label-position="left">
              <el-form-item label="会员卡号:">
                <div style="display: flex; justify-content: space-between;" v-if="customForm.membershipCardNumber && customForm.membershipCardNumber !='' && customForm.membershipCardNumber !='-'">
                  {{customForm.membershipCardNumber}}
                  <!-- fda3ff4e3d8745a6bebb9929dfeb659b -->
                  <el-popover placement="top" width="200" v-model="cardvisible">
                    <div>
                      <div class="fill-card-title">输入补卡原因：</div>
                      <el-input type="text" v-model.trim="reason" maxlength="50" placeholder="请输入补卡原因"></el-input>
                      <div style="margin-top:16px;text-align:center">
                        <el-button size="mini" @click="cardvisible = false">取 消</el-button>
                        <el-button size="mini" type="primary" v-preventReClick @click="confirmApplyCard">确定</el-button>
                      </div>
                    </div>
                    <el-button slot="reference" size="small" type="text" @click="reason=''"
                      >补卡</el-button>
                  </el-popover>
                </div>
                <div style="display: flex; justify-content: space-between;" v-else>
                  {{customForm.membershipCardNumber}}                  
                </div>
                <div v-if="fillCardList.length">
                  <p v-if="!showAllVipCard">
                    <!-- <span style="display:inline-block;margin-right:20px;">{{fillCardList[0].cardNumber}}</span> -->
                    <el-tooltip placement="right">
                      <div slot="content">{{fillCardList[0].reapplyDate}}<br />补卡原因：{{fillCardList[0].reason}}</div>
                      <el-button size="small" type="text">补卡记录{{fillCardList.length}}</el-button>
                    </el-tooltip>
                  </p>
                  <p v-show="showAllVipCard" v-for="(item,index) in fillCardList" :key="index">
                    <!-- <span style="display:inline-block;margin-right:20px;">{{item.cardNumber}}</span> -->
                    <el-tooltip placement="right">
                      <div slot="content">{{item.reapplyDate}}<br />补卡原因：{{item.reason}}</div>
                      <el-button size="small" type="text">补卡记录{{fillCardList.length - index}}</el-button>
                    </el-tooltip>
                  </p>
                  <el-button v-if="fillCardList.length > 1 && !showAllVipCard" size="small" type="text"
                    @click="showAllVipCard = true">展示更多</el-button>
                  <el-button v-if="fillCardList.length > 1 && showAllVipCard" size="small" type="text"
                    @click="showAllVipCard = false">收起</el-button>
                </div>
              </el-form-item>
              <el-form-item label="姓名:">
                <p>{{customForm.patientName}}</p>
              </el-form-item>
              <el-form-item label="身份证号:">
                <p>{{customForm.idCard}}</p>
              </el-form-item>
              <el-form-item label="电话号码:">
                <p>{{customForm.mobile}}</p>
              </el-form-item>
              <el-form-item label="性别:">
                <p>{{ customForm.sex == 1 ? '男' : customForm.sex == 2 ? '女' : '未知' }}</p>
              </el-form-item>

              <el-form-item label="出生年月:">
                <p>{{customForm.birthday}}</p>
              </el-form-item>

              <el-form-item label="民族:">
                <p>{{customForm.nation}}</p>
              </el-form-item>

              <el-form-item label="工作单位:">
                <p v-if="!isEdit">{{customForm.workingOrgan}}</p>
                <el-input type="text" v-else v-model.trim="customForm.workingOrgan" placeholder="请输入内容" maxlength="255">
                </el-input>
              </el-form-item>
              <el-form-item label="职务工种:">
                <p v-if="!isEdit">{{customForm.profession}}</p>
                <el-input type="text" v-else v-model.trim="customForm.profession" placeholder="请输入内容" maxlength="255">
                </el-input>
              </el-form-item>
              <el-form-item label="现有文化程度:">
                <p v-if="!isEdit">{{customForm.educationalLevel}}</p>
                <el-select v-else v-model="customForm.educationalLevel" placeholder="请选择" clearable>
                  <el-option label="博士及以上" value="博士及以上"></el-option>
                  <el-option label="研究生" value="研究生"></el-option>
                  <el-option label="本科" value="本科"></el-option>
                  <el-option label="大专" value="大专"></el-option>
                  <el-option label="高专" value="高专"></el-option>
                  <el-option label="中专" value="中专"></el-option>
                  <el-option label="技工学校" value="技工学校"></el-option>
                  <el-option label="高中" value="高中"></el-option>
                  <el-option label="初中" value="初中"></el-option>
                  <el-option label="小学" value="小学"></el-option>
                  <el-option label="文盲或半文盲" value="文盲或半文盲"></el-option>
                </el-select>
                <!-- <el-input type="text" v-else v-model.trim="customForm.educationalLevel" placeholder="请输入内容">
                </el-input> -->
              </el-form-item>
              <el-form-item label="何年参加何党派团体:">
                <p v-if="!isEdit">{{customForm.joinPartyTime}}{{customForm.politicalBackground}}</p>
                <div v-else style="display:flex;flex:1;">
                  <el-date-picker v-model="customForm.joinPartyTime" value-format="yyyy-MM-dd" style="margin-right: 4px"
                    type="date" placeholder="选择日期">
                  </el-date-picker>
                  <el-input type="text" v-model.trim="customForm.politicalBackground" placeholder="请输入内容"
                    maxlength="255">
                  </el-input>
                </div>
              </el-form-item>
              <el-form-item label="懂得何种外语:">
                <p v-if="!isEdit">{{customForm.languageSkills}}</p>
                <el-input type="text" v-else v-model.trim="customForm.languageSkills" placeholder="请输入内容"
                  maxlength="255">
                </el-input>
              </el-form-item>
              <el-form-item label="特长与爱好:">
                <p v-if="!isEdit">{{customForm.specialtyAndHobbies}}</p>
                <el-input type="textarea" v-else v-model.trim="customForm.specialtyAndHobbies" placeholder="请输入内容"
                  maxlength="255">
                </el-input>
              </el-form-item>
              <el-form-item label="宗教信仰:">
                <p v-if="!isEdit">{{customForm.religiousBelief}}</p>
                <el-input type="text" v-else v-model.trim="customForm.religiousBelief" placeholder="请输入内容"
                  maxlength="255">
                </el-input>
              </el-form-item>
              <el-form-item label="是否侨眷:">
                <p v-if="!isEdit">{{customForm.relativesOfNationalsLivingAbroad}}</p>
                <el-radio-group v-else v-model="customForm.relativesOfNationalsLivingAbroad">
                  <el-radio label="是">是</el-radio>
                  <el-radio label="否">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="家庭地址:">
                <p v-if="!isEdit">{{customForm.province}}{{customForm.city}}{{customForm.county}}</p>
                <el-cascader v-else placeholder="选择或者搜索" v-model="customForm.cityList" :props="setKesDept"
                  :options="options" filterable clearable @change="addressChange" style="width:100%;">
                </el-cascader>
              </el-form-item>
              <el-form-item label="详细地址:">
                <p v-if="!isEdit">{{customForm.address}}</p>
                <el-input v-else type="text" v-model.trim="customForm.address" placeholder="请输入内容" maxlength="255">
                </el-input>
              </el-form-item>
              <el-form-item label="邮政编码:">
                <p v-if="!isEdit">{{customForm.postalCode}}</p>
                <el-input type="text" v-else v-model.trim="customForm.postalCode" placeholder="请输入内容" maxlength="255">
                </el-input>
              </el-form-item>
              <el-form-item label="紧急联系人:">
                <p v-if="!isEdit">{{customForm.emergencyContact}}</p>
                <el-input type="text" v-else v-model.trim="customForm.emergencyContact" placeholder="请输入内容"
                  maxlength="10">
                </el-input>
              </el-form-item>
              <el-form-item label="紧急联系人手机号码:">
                <p v-if="!isEdit">{{customForm.emergencyContactNumber}}</p>
                <el-input type="text" v-else v-model.trim="customForm.emergencyContactNumber" placeholder="请输入内容"
                  maxlength="11">
                </el-input>
              </el-form-item>
              <el-form-item label="癌症名称:">
                <p v-if="!isEdit">{{customForm.cancerNameText}}</p>
                <el-select v-else v-model="customForm.cancerNameText" @change="cancerNameTextChange" placeholder="请选择"
                  clearable style="width:100%;">
                  <el-option v-for="(item,index) in cancerNameList" :key="index" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
                <p v-if="customForm.cancerNameText == '其他' && !isEdit">{{customForm.cancerName}}</p>
                <el-input type="text" v-if="customForm.cancerNameText == '其他' && isEdit"
                  v-model.trim="customForm.cancerName" placeholder="请输入内容" maxlength="255">
                </el-input>
              </el-form-item>
              <el-form-item label="确诊医院:">
                <p v-if="!isEdit">{{customForm.confirmedDiagnosisHospital}}</p>
                <el-input type="text" v-else v-model.trim="customForm.confirmedDiagnosisHospital" placeholder="请输入内容"
                  maxlength="255">
                </el-input>
              </el-form-item>
              <el-form-item label="确诊日期:">
                <p v-if="!isEdit">{{customForm.confirmedDiagnosisTime}}</p>
                <el-date-picker v-else v-model="customForm.confirmedDiagnosisTime" value-format="yyyy-MM-dd" type="date"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>

              <el-form-item label="治疗简况:">
                <p v-if="!isEdit">{{customForm.treatment.join(',')}}</p>
                <el-checkbox-group v-else v-model="customForm.treatment">
                  <el-checkbox label="手术"></el-checkbox>
                  <el-checkbox label="化疗"></el-checkbox>
                  <el-checkbox label="放疗"></el-checkbox>
                  <el-checkbox label="免疫治疗"></el-checkbox>
                  <el-checkbox label="中医中药"></el-checkbox>
                  <el-checkbox label="其它"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="体能锻炼:">
                <p v-if="!isEdit">{{customForm.physicalExercise.join(',')}} {{otherExercise}}</p>
                <el-checkbox-group v-else v-model="customForm.physicalExercise">
                  <el-checkbox label="郭林新气功"></el-checkbox>
                  <el-checkbox label="其它气功"></el-checkbox>
                  <el-checkbox label="太极拳"></el-checkbox>
                  <el-checkbox label="太极剑"></el-checkbox>
                  <el-checkbox label="保健操"></el-checkbox>
                  <el-checkbox label="交际舞"></el-checkbox>
                  <el-checkbox label="慢跑"></el-checkbox>
                  <el-checkbox label="散步"></el-checkbox>
                  <el-checkbox label="其它"></el-checkbox>
                </el-checkbox-group>
                <el-input v-if="isEdit && customForm.physicalExercise.indexOf('其它') != -1" type="text"
                  v-model.trim="otherExercise" placeholder="请输入内容" maxlength="255">
                </el-input>
              </el-form-item>
              <el-form-item label="现在属于:">
                <p v-if="!isEdit">{{customForm.personalSituation.join(',')}}</p>
                <el-checkbox-group v-else v-model="customForm.personalSituation">
                  <el-checkbox label="病假"></el-checkbox>
                  <el-checkbox label="退养"></el-checkbox>
                  <el-checkbox label="退休（是）"></el-checkbox>
                  <el-checkbox label="离休"></el-checkbox>
                  <el-checkbox label="上班"></el-checkbox>
                  <el-checkbox label="志愿者"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="爱人姓名:">
                <p v-if="!isEdit">{{customForm.spouseName}}</p>
                <el-input type="text" v-else v-model.trim="customForm.spouseName" placeholder="请输入内容" maxlength="255">
                </el-input>
              </el-form-item>
              <el-form-item label="病孩家长姓名:">
                <p v-if="!isEdit">{{customForm.parentName}}</p>
                <el-input type="text" v-else v-model.trim="customForm.parentName" placeholder="请输入内容" maxlength="255">
                </el-input>
              </el-form-item>
              <!-- <el-form-item label="病孩工作单位new:">
                <p v-if="!isEdit">{{customForm.parentWorkingOrgan}}</p>
                <el-input type="text" v-else v-model.trim="customForm.parentWorkingOrgan" placeholder="请输入内容" maxlength="255">
                </el-input>
              </el-form-item>
              <el-form-item label="病孩工作职务new:">
                <p v-if="!isEdit">{{customForm.parentProfession}}</p>
                <el-input type="text" v-else v-model.trim="customForm.parentProfession" placeholder="请输入内容" maxlength="255">
                </el-input>
              </el-form-item> -->
              <el-form-item label="病孩家长工作单位及职务:">
                <p v-if="!isEdit">{{customForm.parentWorkingOrgan}}{{customForm.parentProfession}}</p>
                <div v-if="isEdit" style="display:flex">
                  <el-input type="text" v-model.trim="customForm.parentWorkingOrgan" placeholder="请输入内容"
                    style="margin-right:10px" maxlength="255">
                  </el-input>
                  <el-input type="text" v-model.trim="customForm.parentProfession" placeholder="请输入内容" maxlength="255">
                  </el-input>
                </div>
              </el-form-item>
              <el-form-item label="家长联系电话:">
                <p v-if="!isEdit">{{customForm.parentPhone}}</p>
                <el-input type="text" v-else v-model.trim="customForm.parentPhone" maxlength="11" placeholder="请输入内容">
                </el-input>
              </el-form-item>
              <el-form-item label="入会目的:">
                <p v-if="!isEdit">{{customForm.purpose}}</p>
                <el-input type="textarea" v-else v-model.trim="customForm.purpose" placeholder="请输入内容" maxlength="255">
                </el-input>
              </el-form-item>
              <el-form-item label="建议和愿望:">
                <p v-if="!isEdit">{{customForm.suggestionsAndWishes}}</p>
                <el-input type="textarea" v-else v-model.trim="customForm.suggestionsAndWishes" placeholder="请输入内容"
                  maxlength="255">
                </el-input>
              </el-form-item>
              <el-form-item label="离、退休或退养时间:">
                <p v-if="!isEdit">{{customForm.retiredTime}}</p>
                <!-- <el-input type="text" v-else v-model.trim="ruleForm.kcal" placeholder="请输入内容">
                </el-input> -->
                <!-- :picker-options="predictChildbirthPickerOptions"  -->
                <el-date-picker v-else v-model="customForm.retiredTime" value-format="yyyy-MM-dd"
                  style="margin-right: 4px" :clearable="false" type="date" placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="入会介绍人:">
                <p v-if="!isEdit">{{customForm.introducer}}</p>
                <el-input type="text" v-else v-model.trim="customForm.introducer" placeholder="请输入内容" maxlength="255">
                </el-input>
              </el-form-item>
              <el-form-item label="本人照片:">
                <!-- <img :src="customForm.photo" alt="" style="width:56px"> -->
                <el-image v-if="customForm.photo" style="width:56px" :src="customForm.photo"
                  :preview-src-list="[customForm.photo]">
                </el-image>
              </el-form-item>
              <el-form-item label="身份证照片:">
                <span>
                  <el-image v-if="customForm.idCardFront" style="margin-right:10px;width:110px"
                    :src="customForm.idCardFront" :preview-src-list="[customForm.idCardFront,customForm.idCardBack]">
                  </el-image>
                  <el-image v-if="customForm.idCardBack" style="width:110px" :src="customForm.idCardBack"
                    :preview-src-list="[customForm.idCardFront,customForm.idCardBack]">
                  </el-image>
                  <!-- <img :src="customForm.idCardFront" alt="" style="margin-right:10px;width:110px">
                  <img :src="customForm.idCardBack" alt="" style="width:110px"> -->
                </span>
              </el-form-item>
              <!-- {{ customForm.casePhoto }} -->
              <el-form-item label="病历照片:">
                <span>
                  <!-- <el-image v-if="customForm.idCardFront" style="margin-right:10px;width:110px"
                    :src="customForm.idCardFront" :preview-src-list="[customForm.idCardFront,customForm.idCardBack]">
                  </el-image> -->
                  <!-- <el-image v-if="customForm.casePhoto" style="width:110px" :src="customForm.casePhoto"
                    :preview-src-list='customForm.casePhoto'>
                  </el-image> -->
                  <!-- <img :src="customForm.idCardFront" alt="" style="margin-right:10px;width:110px">
                  <img :src="customForm.idCardBack" alt="" style="width:110px"> -->
                  <el-image v-for="(item,i) in customForm.casePhotoNew" :key="i"
                    style="width:110px;height:146px;margin-right:10px;" :src="item" :preview-src-list='[item]'>
                  </el-image>
                </span>
              </el-form-item>
              <el-form-item label="驳回记录:">
                <p>{{ customForm.approvalRecord && customForm.approvalRecord.rejectReason }}</p>
                <!-- <el-input type="text" v-else
                  v-model.trim="customForm.approvalRecord && customForm.approvalRecord.rejectReason" placeholder="请输入内容"
                  maxlength="50">
                </el-input> -->
              </el-form-item>
              <div class="btn" v-if="customForm.approvalRecord && customForm.approvalRecord.status == 2">
                <el-button type="primary" plain @click="approvedClick" size="small" style="margin-right:20px;"
                  v-if="customForm.approvalRecord && customForm.approvalRecord.status == 2">审核通过
                </el-button>
                <!-- <el-button type="primary" plain @click="refuseClick" size="small">拒绝</el-button> -->
                <el-popover placement="top" width="200" v-model="refuseCardvisible">
                  <div>
                    <div class="fill-card-title">请填写驳回原因：</div>
                    <el-input type="textarea" v-model.trim="refuseReason" maxlength="35" resize="none" show-word-limit
                      placeholder="请输入驳回原因"></el-input>
                    <div style="margin-top:16px;text-align:center">
                      <el-button size="mini" @click="refuseCardvisible = false">取 消</el-button>
                      <el-button size="mini" type="primary" v-preventReClick @click="refuseClick">确定</el-button>
                    </div>
                  </div>
                  <el-button slot="reference" size="small" type="danger" @click="refuseReason=''">拒绝</el-button>
                </el-popover>
              </div>
            </el-form>
          </div>
          <!-- <div class="btn">
            <el-button type="primary" plain @click="isEdit = !isEdit" v-if="!isEdit" size="small">编辑</el-button>
            <el-button type="primary" plain @click="submitHandel" v-else size="small">保存</el-button>
          </div> -->
        </div>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import local from "@/utils/local.js";
import { approve, regionAll, getPatientDetailedInformationVO } from "../../api";
import { DEEP_CLONE } from "@/utils/constants";
import {
  selectByPatientIdAndHospitalId,
  reapplyVipCard,
  newReapplyRecord,
  updateCustome
} from "@/api/Patientmanagement.js";
import { getByApprovalRecordld, terminologyMultipleInsert } from "../../api";
export default {
  data() {
    return {
      orgHospitalId: local.get("hospitalId"),
      openCustom: true,
      customForm: {
        treatment: [],
        physicalExercise: [],
        personalSituation: [],
        cancerNameText:'',
        cancerName:''
      },
      cardvisible: false,
      showAllVipCard: false,
      refuseCardvisible: false,
      reason: "",
      refuseReason: "",
      fillCardList: [],
      isEdit: false, //false 为编辑 true 为保存
      otherExercise: "",
      ruleForm: {
        patientName: "", //姓名
        sex: "", //性别 1男 2女
        age: "", //年龄
        bloodType: "", //血型
        nation: "", //民族
        nativePlace: "", //籍贯
        maritalStatus: "", //1 已婚 2 未婚
        birthday: "", //出生日期
        pregnancyStatus: "", //是否孕妇 1是 2否
        occupation: "", //职业
        labour: "", //体力劳动等级 1轻体力劳动 2 中等体力劳动 3重体力劳动 4极重体力劳动
        certificate: "", //证件类型 未知枚举
        idCard: "", //证件号码
        mobile: "", //	联系方式
        address: "", //	当前居住地址
        province: "", //省
        city: "", //市
        county: "", //区
        lastMenstrualPeriod: "", //末次月经
        predictChildbirth: "", //预产期
        embryoNumber: "", //胎数 1 单胎 2 双胎 3 多胎
        height: "", //当前身高
        weight: "", //当前体重
        pregnancyWeight: "", //孕前体重
        ibw: "", //理想体重
        weightIbm: "", //当前体重占理想体重
        bmi: "", //BMI
        pregnancyBmi: "", //孕前BMI
        waistline: "", //腰围
        hipline: "", //臀围
        gestationalWeeks: "", //孕周
        whr: "", //腰臀比
        kcal: "", //基础代谢
        nutritionalRisk: "", //营养风险:
        id: "",
        relativeVO: {}
      },
      rulesqw: {
        bloodType: [{ message: "请选择血型", trigger: "change" }],
        pregnancyStatus: [{ message: "请选择是否孕产妇", trigger: "change" }],
        labour: [{ message: "请选择体力劳动等级", trigger: "change" }],
        lastMenstrualPeriod: [
          { message: "请选择末次月经时间", trigger: "change" }
        ],
        predictChildbirth: [{ message: "请选择预产期", trigger: "change" }],
        embryoNumber1: [{ message: "请选择胎数", trigger: "change" }],
        height: [
          // {  message: '请输入当前身高', type:'number', trigger: 'blur' },
          { message: "请输入当前身高", trigger: "blur" }
        ],
        weight: [{ message: "请输入当前体重", trigger: "blur" }]
        // pregnancyWeightOne: [
        //     {  message: '请输入孕前体重', trigger: 'blur' },
        // ],
      }, //输入规则
      options: [],
      setKesDept: {
        value: "name",
        label: "name"
      },
      jargonList: [],
      cancerNameList: [
        {
          label: "肺病种组",
          value: "肺病种组"
        },
        {
          label: "肝病种组",
          value: "肝病种组"
        },
        {
          label: "肠病种组",
          value: "肠病种组"
        },
        {
          label: "乳腺系组",
          value: "乳腺系组"
        },
        {
          label: "胃病种组",
          value: "胃病种组"
        },
        {
          label: "泌尿系组",
          value: "泌尿系组"
        },
        {
          label: "甲状腺组",
          value: "甲状腺组"
        },
        {
          label: "鼻烟喉组",
          value: "鼻烟喉组"
        },
        {
          label: "妇科系组",
          value: "妇科系组"
        },
        {
          label: "其他",
          value: "其他"
        }
      ]
    };
  },
  created() {
    this.regionAll();
    if (this.$route.query.patientId) {
      this.getHzPatientData();
      this.getPatientDetailedInformationVORequest();
      this.getVipCardInfo();
    }
  },
  watch: {},
  computed: {
    getUserDetailsData() {
      return this.getDataDetail(this.userDetailsData);
    }
  },
  mounted() {},

  methods: {
    handleFoldCustom() {
      this.openCustom = !this.openCustom;
    },
    async refuseClick() {
      if (!this.refuseReason) {
        this.$message.error("请输入驳回原因");
        return;
      }
      // let res = await reapplyVipCard({
      //   hospitalId: "1630497377808076802",
      //   patientId: this.$route.query.patientId,
      //   reason: this.refuseReason
      // });
      // if (res.code == 0) {
      //   this.refuseCardvisible = false;
      // }
      approve({
        approvalRecordId: this.$route.query.id,
        isPass: false,
        remark: this.refuseReason
      }).then(res => {
        if (res.code == 0) {
          this.refuseCardvisible = false;
          this.getHzPatientData();
          this.getPatientDetailedInformationVORequest();
          this.getVipCardInfo();
          this.$message.success("拒绝成功");
        }
      });
    },
    async getVipCardInfo() {
      this.fillCardList = [];
      let res = await newReapplyRecord({
        hospitalId: "1630497377808076802",
        patientId: this.$route.query.patientId
      });
      if (res.code == 0) {
        if (res.data) {
          this.fillCardList = res.data;
        }
        // console.log(this.fillCardList)
      }
    },
    async confirmApplyCard() {
      if (!this.reason) {
        this.$message.error("请输入补卡原因");
        return;
      }
      let res = await reapplyVipCard({
        hospitalId: "1630497377808076802",
        patientId: this.$route.query.patientId,
        reason: this.reason
      });
      if (res.code == 0) {
        this.cardvisible = false;
        this.getHzPatientData();
        this.getPatientDetailedInformationVORequest();
        this.getVipCardInfo();
      }
    },
    submitHandel() {
      if (this.isEdit) {
        // if (this.orgHospitalId == "1630497377808076802") {
        let phoneReg = /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
        if (!this.customForm.workingOrgan) {
          this.$message.error("请输入工作单位");
          return;
        }
        if (!this.customForm.profession) {
          this.$message.error("请输入职务工种");
          return;
        }
        if (!this.customForm.educationalLevel) {
          this.$message.error("请选择现有文化程度");
          return;
        }
        if (
          !this.customForm.joinPartyTime ||
          !this.customForm.politicalBackground
        ) {
          this.$message.error("请填选何年参加何党派团体");
          return;
        }
        if (!this.customForm.specialtyAndHobbies) {
          this.$message.error("请输入特长与爱好");
          return;
        }

        if (!this.customForm.religiousBelief) {
          this.$message.error("请输入宗教信仰");
          return;
        }

        if (this.customForm.cityList.length <= 0) {
          this.$message.error("请选择家庭地址");
          return;
        }
        if (this.customForm.address == null || this.customForm.address == "") {
          this.$message.error("请输入详细地址");
          return;
        }
        if (
          this.customForm.emergencyContact == null ||
          this.customForm.emergencyContact == ""
        ) {
          this.$message.error("请输入紧急联系人");
          return;
        }
        if (
          this.customForm.emergencyContactNumber == null ||
          this.customForm.emergencyContactNumber == ""
        ) {
          this.$message.error("请输入紧急联系人手机号码");
          return;
        } else if (
          this.customForm.emergencyContactNumber &&
          !phoneReg.test(this.customForm.emergencyContactNumber)
        ) {
          this.$message.error("请输入正确格式的紧急联系人手机号码");
          return;
        }

        if (!this.customForm.cancerNameText || this.customForm.cancerNameText == "") {
          this.$message.error("请选择癌症名称");
          return;
        } else if (
          this.customForm.cancerNameText == "其他" &&
          (this.customForm.cancerName == "" ||
            this.customForm.cancerName == null)
        ) {
          this.$message.error("请填写其他癌症名称");
          return;
        }

        // if (!this.customForm.contacts) {
        //   this.$message.error("请输入联系人");
        //   return;
        // }
        if (!this.customForm.confirmedDiagnosisTime) {
          this.$message.error("请选择确诊日期");
          return;
        }
        if (this.customForm.treatment.length == 0) {
          this.$message.error("请选择治疗简况");
          return;
        }
        if (!this.customForm.purpose) {
          this.$message.error("请填写入会目的");
          return;
        }
        // }

        if (
          this.customForm.parentPhone &&
          !phoneReg.test(this.customForm.parentPhone)
        ) {
          this.$message.error("请输入正确格式的家长联系电话");
          return;
        }
        // 新增术语
        let jargonList = this.jargonList.map(item => {
          return {
            id: item.id,
            patientId: item.patientId,
            value: item.value
          };
        });
        let subParams = JSON.parse(JSON.stringify(this.ruleForm));
        if (!subParams.height) {
          subParams.height = "";
        }
        if (!subParams.weight) {
          subParams.weight = "";
        }
        let customFormParam = DEEP_CLONE(this.customForm);
        customFormParam.retiredTime = customFormParam.retiredTime
          ? customFormParam.retiredTime
          : "";
        customFormParam.personalSituation = customFormParam.personalSituation.join(
          ","
        );
        customFormParam.physicalExercise = this.otherExercise
          ? customFormParam.physicalExercise.join(",") +
            `,${this.otherExercise}`
          : customFormParam.physicalExercise.join(",");
        customFormParam.treatment = customFormParam.treatment.join(",");
        Promise.all([
          // UpdatepatientArchiesLeft(subParams),
          terminologyMultipleInsert(jargonList),
          updateCustome({ ...subParams, ...customFormParam })
        ])
          .then(result => {
            this.$message.success("修改成功");
            this.isEdit = false;
            this.$emit("userEdit", 1);
          })
          .catch(error => {
            this.loading = false;
          });
      }
    },
    async getHzPatientData() {
      // console.log(this.$store.state.serviceItem)
      // if (!this.$store.state.serviceItem.hospitalId) return
      // // return
      // let res = await selectByPatientIdAndHospitalId({
      let res = await getByApprovalRecordld({
        // hospitalId: "1630497377808076802", // this.$store.state.serviceItem.hospitalId,
        // patientId: this.$route.query.patientId
        approvalRecordId: this.$route.query.id
      });
      if (res.code == 0) {
        if (res.data) {
          res.data.treatment = res.data.treatment
            ? res.data.treatment.split(",")
            : [];
          res.data.physicalExercise = res.data.physicalExercise
            ? res.data.physicalExercise.split(",")
            : [];
          if (
            res.data.physicalExercise.indexOf("其它") != -1 &&
            res.data.physicalExercise[res.data.physicalExercise.length - 1] !=
              "其它"
          ) {
            this.otherExercise =
              res.data.physicalExercise[res.data.physicalExercise.length - 1];
            res.data.physicalExercise.pop();
          }
          res.data.personalSituation = res.data.personalSituation
            ? res.data.personalSituation.split(",")
            : [];

          this.customForm = res.data;
          this.customForm.casePhotoNew = res.data.casePhoto
            ? res.data.casePhoto.split(",")
            : [];
          let arrCancer = this.cancerNameList.filter(item => {
            return item.value == res.data.cancerName
          })
          console.log(arrCancer,"arrCancer");
          console.log(res.data.cancerName,"res.data.cancerName");
          if(arrCancer.length > 0){
            // this.customForm.cancerName = '';
            this.customForm.cancerNameText = res.data.cancerName
          }else{
            this.customForm.cancerName = res.data.cancerName
            this.customForm.cancerNameText = '其他'
          }
          console.log(this.customForm.cancerName,"this.customForm.cancerName"); 
          console.log(this.customForm.cancerNameText,"this.customForm.cancerNameText");
          this.$set(this.customForm, "cityList", []);
          this.customForm.cityList[0] = res.data.province;
          this.customForm.cityList[1] = res.data.city;
          this.customForm.cityList[2] = res.data.county;
        } else {
          this.customForm = {
            treatment: [],
            physicalExercise: [],
            personalSituation: []
          };
        }
      }
    },
    approvedClick() {
      approve({
        approvalRecordId: this.$route.query.id,
        isPass: true,
        remark: ""
      }).then(res => {
        if (res.code == 0) {
          this.getHzPatientData();
          this.getPatientDetailedInformationVORequest();
          this.getVipCardInfo();
          this.$message.success("审核成功");
        }
      });
    },
    regionAll() {
      regionAll().then(res => {
        if (res.code == 0) {
          this.options = res.data;
        }
      });
    },
    getDataDetail(value) {
      if (!value) return false;
      Object.keys(this.ruleForm).forEach(item => {
        if (["height", "weight", "pregnancyWeight"].includes(item))
          this.ruleForm[item] = value[item] * 1 || undefined;
        else this.ruleForm[item] = value[item] || "";
      });
      // 如果档案数据为空，取杭州分会下填入的数据
      // 如果档案有数据，则以档案的显示
      this.ruleForm.sex = this.ruleForm.sex
        ? this.ruleForm.sex
        : this.customForm.sex;
      this.ruleForm.patientName = this.ruleForm.patientName
        ? this.ruleForm.patientName
        : this.customForm.patientName;
      this.ruleForm.nation = this.ruleForm.nation
        ? this.ruleForm.nation
        : this.customForm.nation;
      this.ruleForm.mobile = this.ruleForm.mobile
        ? this.ruleForm.mobile
        : this.customForm.mobile;
      this.ruleForm.idCard = this.ruleForm.idCard
        ? this.ruleForm.idCard
        : this.customForm.idCard;
      this.ruleForm.birthday = this.ruleForm.birthday
        ? this.ruleForm.birthday
        : this.customForm.birthday;
      this.ruleForm.address = this.ruleForm.address
        ? this.ruleForm.address
        : this.customForm.address;
      return this.ruleForm;
    },
    addressChange(e) {
      console.log(e, "eee");
      this.customForm.province = e[0];
      this.customForm.city = e[1];
      this.customForm.county = e[2];
      console.log(this.customForm.cityList, "customForm.cityList");
    },
    getPatientDetailedInformationVORequest() {
      getPatientDetailedInformationVO({
        patientId: this.$route.query.patientId,
        type: 1,
        current: 1,
        size: 10,
        keyWord: "",
        wholeCourseId: ""
      }).then(res => {
        if (res.code == 0) {
          if (
            res.data &&
            res.data.personalInformationVO &&
            res.data.personalInformationVO.patientArchivesLeftVO
          ) {
            this.customForm.idCard =
              res.data.personalInformationVO.patientArchivesLeftVO.idCard;
            this.customForm.patientName =
              res.data.personalInformationVO.patientArchivesLeftVO.patientName;
            this.customForm.mobile =
              res.data.personalInformationVO.patientArchivesLeftVO.mobile;
            this.customForm.sex =
              res.data.personalInformationVO.patientArchivesLeftVO.sex;
            this.customForm.birthday =
              res.data.personalInformationVO.patientArchivesLeftVO.birthday;
            this.customForm.nation =
              res.data.personalInformationVO.patientArchivesLeftVO.nation;
          }
        }
      });
    },
    cancerNameTextChange(e) {
      this.$set(this.customForm,'cancerNameText',e);
      if(e != "其他"){
        this.$set(this.customForm,'cancerName',e);
      }else{
        // this.customForm.cancerName = '';
        this.$set(this.customForm,'cancerName','');
      }
      console.log(this.customForm.cancerNameText,"sss");
      this.$forceUpdate();
    }
  }
};
</script>
<style lang="less" scoped>
@import "./index.less";

.openCustom-box {
  width: 66%;
  padding-left: 30px;
  padding-right: 30px;
  height: 800px;
  overflow-y: auto;
}

.openCustom-box::-webkit-scrollbar-track {
  // -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.openCustom-box::-webkit-scrollbar {
  width: 5px;
  background-color: #f5f5f5;
}

.openCustom-box::-webkit-scrollbar-thumb {
  border-radius: 3px;
  // -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #a8a8a8;
}
.kins-folk-info {
  position: absolute;
  top: -100px;
  right: -345px;
  z-index: 2;
  /deep/.el-form-item {
    margin-bottom: 22px;
  }
}
.fill-card-title {
  font-size: 12px;
  color: #666666;
  line-height: 10px;
  margin-bottom: 20px;
}
.open-tag {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  .tag-title {
    font-size: 14px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    display: flex;
    align-items: center;
  }
  .open-status {
    color: #333;
    cursor: pointer;
    i {
      margin-left: 6px;
    }
  }
  span {
    display: inline-block;
    width: 4px;
    height: 15px;
    background: #1a7bfc;
    margin-right: 10px;
  }
}
.list-question-wrap {
  height: 100%;
}

.gaode_map {
  width: 580px;
  height: 300px;
  border-radius: 8px;
}

.el-header {
  height: auto !important;
  padding: 0;

  .manage-head {
    background-color: #fff;
    padding: 24px 24px 0px 24px;
  }
}

.el-main {
  width: 100%;

  .main-content-list {
    padding: 15px;
    background-color: #fff;
    height: 100vh;
    .el-button {
      font-weight: 400;
    }
  }
}

/deep/.el-tabs__header {
  margin: 0 !important;
}

.el-pagination {
  text-align: right;
  padding: 15px;
  background-color: #fff;
}

/deep/ .el-tabs__nav-wrap::after {
  background-color: #fff;
}

/deep/ .flexs_header .el-form-item__content {
  margin-left: 0px !important;
  // margin-right: 10px;
}

/deep/.dialogBox {
  .el-form-item {
    width: 100%;
    display: flex;
  }

  .el-form-item__content {
    width: 100%;
  }
}

.buttonBoxs {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.marginBottom {
  margin-bottom: 14px;
}

.flexs {
  display: flex;
  flex-wrap: wrap;
}

.text {
  text-align: left;
  color: #333333;
  font-size: 14px;
  line-height: 22px;
  padding-bottom: 20px;

  span:nth-child(2) {
    color: #333;
  }

  span:nth-child(1) {
    color: #999;
  }
}

.margin-l10 {
  margin-left: 20px;
}

.dialog-footer {
  margin-bottom: 20px;

  .el-button {
    width: 110px;
    margin-right: 20px;
  }
}

.fieldWidth {
  display: inline-block;
  max-width: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.selectwidth {
  width: 100%;
}

.pagination-container {
  margin: 20px auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.top_title {
  display: flex;
  align-items: center;

  span {
    width: 4px;
    height: 15px;
    background: #1a7bfc;
    margin-right: 10px;
    display: block;
  }

  font-size: 14px;
  font-weight: bold;
  color: #333333;
  margin: 20px 0;
}

.description {
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

/deep/ .el-tree {
  padding-top: 15px;
  padding-left: 10px;

  // 不可全选样式
  .el-tree-node {
    .is-leaf + .el-checkbox .el-checkbox__inner {
      display: inline-block;
    }

    .el-checkbox .el-checkbox__inner {
      display: none;
    }
  }
}

/deep/ .tabels .el-table td,
.el-table th {
  padding: 0 !important;
}

/deep/ .tabels .el-table th {
  padding: 0 !important;
}

.phone-container {
  width: 414px;
  height: 736px;
  border: 1px solid #999;
  margin: 0 auto;
}

/deep/ .el-table .DisableSelection .cell:before {
  content: "选择";
  position: absolute;
}

.inputwidth_name {
  width: 330px;
}

/deep/.a-tag {
  border-radius: 11px;
  margin-right: 15px;
}

/deep/.el-form-item__content .el-input-padd .el-input__inner {
  padding-right: 80px !important;
}
/deep/.el-form-item__content {
  line-height: 35px;
}

.popconfirmbox .el-popconfirm__main {
  align-items: flex-start !important;
  line-break: anywhere !important;
  margin: 0 0 10px 0 !important;
}

/deep/.el-textarea__inner {
  padding-bottom: 25px;
  min-height: auto !important;
}

/deep/ .el-textarea .el-input__count {
  height: 20px;
  line-height: 20px;
  background: none;
  right: 18px;
}
</style>
